export default __webpack_public_path__ + "static/media/prize_3.min.51c35895.png";